import React from 'react'
import { useMutation } from 'react-query'
import * as Sentry from '@sentry/react'
import { postLogPaypalFailureAuthorization } from '../api'
import Cookies from 'js-cookie'
import { ERROR_LOG_PAYPAL_FAILURE_AUTHORIZATION } from '../errorConstants'

const useLogPaypalFailureAuthorization = () => {
  const { mutate, mutateAsync, data, error, isLoading, isSuccess, isError } =
    useMutation(postLogPaypalFailureAuthorization, {
      onError: (error, context) => {
        const {
          response: {
            data: { message: errorMessage },
          },
        } = error
        error.name = errorMessage ?? ERROR_LOG_PAYPAL_FAILURE_AUTHORIZATION
        Sentry.captureException(error, {
          extra: {
            context: JSON.stringify(context, null, 2),
          },
          user: {
            id: JSON.stringify(Cookies.get('GCG_CLIENT_USER_ID')),
          },
        })
      },
    })
  return { mutate, mutateAsync, data, error, isLoading, isSuccess, isError }
}

export default useLogPaypalFailureAuthorization
